export const GenerationSelector = ({ possibleCategories, changeCategory, value }) => {
  return (
    <div className="generationSelector">
      <div>
        <div className="h4Title">Generación</div>
        <select
          onChange={changeCategory}
          className="selectCategory"
          value={value}
          aria-label="Seleccione una generación para filtrar"
        >
          {possibleCategories.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
